// 비밀번호 찾기 페이지
const ForgotPassword = () => {
  return (
    <div>
      <h1>ForgotPassword</h1>
    </div>
  )
}

export default ForgotPassword;